// Utility for required field styles
export const requiredLabelClass = "required-field";

// CSS to be injected into components that use required fields
export const requiredFieldCSS = `
.${requiredLabelClass} {
  position: relative;
}

.${requiredLabelClass}::after {
  content: "*";
  color: #dc2626; /* Tailwind red-600 */
  margin-left: 2px;
  font-weight: bold;
  line-height: 1;
  display: inline;
  vertical-align: baseline;
}
`;